/* eslint-disable no-restricted-globals, no-restricted-imports */
import Cookies, { CookieAttributes } from "js-cookie";
import { useWecomaIntegration } from "./gdpr/use-wecoma-integration";
import { useWebStorage } from "./use-web-storage/use-web-storage";
import { useWebStorageQueue } from "./use-web-storage/use-web-storage-queue";
import { type WebStorageJsonType } from "./use-web-storage/web-storage-type";
import { CookieType } from "./gdpr/wecoma-models";

const { enqueue } = useWebStorageQueue();

export const useLocalStorage = () => useWebStorage("localStorage");

export const useSessionStorage = () => useWebStorage("sessionStorage");

export const useCookieStorage = () => {
    const { cookieTypeConsentedCached } = useWecomaIntegration();

    const getItem = (name: string) => Cookies.get(name);

    const getJson = <T = WebStorageJsonType>(name: string): T => {
        const val = Cookies.get(name);
        if (val === undefined) {
            return null;
        }

        try {
            return JSON.parse(val);
        } catch {
            return null;
        }
    };

    const setItem = (name: string, value: string, type: CookieType, options?: CookieAttributes) => {
        if (!cookieTypeConsentedCached(type)) {
            enqueue({ cookieType: type, itemName: name, storageType: "cookie", value, cookieAttributes: options });
            return false;
        }

        Cookies.set(name, value, { secure: true, ...options });
        return true;
    };

    const setJson = <T = WebStorageJsonType>(name: string, value: T, type: CookieType, options?: CookieAttributes) => {
        const str = JSON.stringify(value);
        return setItem(name, str, type, options);
    };

    const removeItem = (name: string, options?: CookieAttributes) => Cookies.remove(name, options);

    return {
        getItem,
        getJson,
        setItem,
        setJson,
        removeItem,
    };
};
